import styled from 'styled-components';
import { DividerStyle } from './Divider.styles.js';

const defaultProps = {
    decorative: false,
    orientation: 'horizontal',
};
const Divider = styled.hr
    .withConfig({
    shouldForwardProp: prop => ![...Object.keys(defaultProps), 'spacing', 'theme'].includes(prop),
})
    .attrs(({ decorative = defaultProps.decorative, orientation = defaultProps.orientation, ...rest }) => ({
    'aria-orientation': !decorative && orientation === 'vertical'
        ? orientation
        : // Elements with the role separator have an implicit
            // aria-orientation value of horizontal. Never set
            // the aria-orientation if the element is decorative.
            undefined,
    role: decorative
        ? 'presentation'
        : // By default <hr> has an implicit separator role
            undefined,
    ...rest,
})) `
    ${DividerStyle}
`;

export { Divider, defaultProps };
//# sourceMappingURL=Divider.js.map
